export const normalizeInvoiceAccountID = (accountID) => {
  const normalized = Number(accountID);
  return Number.isInteger(normalized) && normalized > 0 ? normalized : null;
};

export const requestInvoiceAccountDetails = async (apiService, accountID) => {
  const normalizedAccountID = normalizeInvoiceAccountID(accountID);
  if (!normalizedAccountID) return null;

  const response = await apiService.getDataFromBackend(
    `getaccountbyid?ID=${encodeURIComponent(normalizedAccountID)}`,
  );
  return response?.data?.data ?? null;
};
